import { Card, Colors, defaultHover, Icon, Text } from '@amelio/ui-library';
import { useState } from 'react';

import type { FeatureFlagKey } from '@/utils/featureFlags';

import { NODE_ENV } from '@/env';

export interface FeatureFlagCalloutProps {
    featureFlag: FeatureFlagKey;
}

export const FeatureFlagCallout = ({ featureFlag }: FeatureFlagCalloutProps) => {
    const [isDisplayed, setIsDisplayed] = useState(true);

    /*
     * TODO: Update this to NODE_ENV === 'development' when we are ready to use API
     * ADO: [FE] Update the FeatureFlag callback to be in development only
     * https://dev.azure.com/ameliodev/Amelio-Performance%20Management/_workitems/edit/8616
     */
    if (NODE_ENV === 'production' || !isDisplayed) {
        return null;
    }

    return (
        <Card
            className={'mb-8'}
            bgColor={'bg-warning-50'}
            borderColor={Colors.WARNING_800}
        >
            <div className={'z-2 flex flex-row justify-between'}>
                <Icon
                    name={'essential-info-circle'}
                    color={Colors.WARNING_800}
                />

                <div className={`${defaultHover}`}>
                    <Icon
                        name={'essential-close-circle'}
                        color={Colors.BASE_500}
                        onClick={() => setIsDisplayed(false)}
                    />
                </div>
            </div>

            <div className={'z-1 -mt-5 ml-10 flex flex-col gap-1.5'}>
                <Text>Hello fellow Amélio team member !👋👋</Text>

                <div className={'flex flex-row gap-1'}>
                    <Text>The</Text>

                    <Text weight={'bold'}>{`${featureFlag.toLocaleLowerCase()}`}</Text>

                    <Text>feature is not enabled at moment</Text>
                </div>

                <div className={'flex flex-row gap-1'}>
                    <Text>
                        But don&apos;t worry, it will be available soon ! In the meantime, you can
                        see the screen with
                    </Text>

                    <Text weight={'bold'}>mocked</Text>

                    <Text>data</Text>
                </div>

                <Text>Cheers ! ★</Text>
            </div>
        </Card>
    );
};
